import { gql } from '@apollo/client';

export const CREATE_QUESTION_WITH_OPTION = gql`
 mutation CreateQuestionWithOption($input: CreateQuestionInput) {
    createQuestionWithOption(input: $input) {
        data {
            questions {
                created_at
                id
                is_published
                question
                updated_at
                video_id
                options {
                    created_at
                    id
                    is_correct_answer
                    option
                    updated_at
                    video_question_id
                }
            }
        }
        error {
            code
            field
            message
        }
    }
}

`;
export const UPDATE_QUESTION_WITH_OPTION = gql`
 mutation UpdateQuestionWithOption($questionId:UUID!,$input: QuestionInput!) {
    UpdateQuestionWithOption(questionId: $questionId, input: $input) {
         data {
            question {
                created_at
                id
                is_published
                question
                updated_at
                video_id
                options {
                    created_at
                    id
                    is_correct_answer
                    option
                    updated_at
                    video_question_id
                }
            }
        }
        error {
            code
            field
            message
        }
    }
}

`;
export const UPDATE_QUESTION_PUBLISED_STATUS = gql`
  mutation UpdateQuestionPublishedStatus($questionId:UUID!,$isPublished:Boolean!) {
    UpdateQuestionPublishedStatus(questionId: $questionId, isPublished: $isPublished) {
        data {
            question {
                created_at
                id
                is_published
                question
                updated_at
                video_id
                options {
                    created_at
                    id
                    is_correct_answer
                    option
                    updated_at
                    video_question_id
                }
            }
        }
        error {
            code
            field
            message
        }
    }
}

`;
export const DELETE_QUESTION_WITH_OPTION = gql`
  mutation DeleteQuestionWithOption($questionId:UUID!) {
    deleteQuestionWithOption(questionId: $questionId) {
        error
        data {
            message
        }
    }
}

`;